var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Hero',{attrs:{"position":"relative","search":true,"image":'banner-hero-1.jpg',"height":"85vh"}}),_c('div',{staticClass:"marge-hero"}),_c('Jobs')],1)}
var staticRenderFns = []

export { render, staticRenderFns }